(function(){
    const viewControllerButtons = document.querySelectorAll("nav.rkn_model_product_view_controllers button")
    const collectionViewer = document.querySelector("div.product-grid:not(.product-grid--scrollarea)")

    viewControllerButtons.forEach((button)=>{
        button.addEventListener('click',(event)=>{
            collectionViewer.dataset.currentView = event.target.dataset.triggers
            const currentlySelectedButton = document.querySelector(".rkn_view_selection_button.is-active")
            currentlySelectedButton.classList.remove("is-active")
            event.target.classList.add("is-active")
        })
    })
})()